module.exports = __webpack_public_path__ + "img/odoo-for-purchansing-min.52c14677.png";